import * as yup from 'yup';
import { TFunction } from 'i18next';
import moment from 'moment';

export const MetricsForm = (t: TFunction): any =>
  yup.object().shape({
    venueId: yup.array().of(yup.string()).min(1, t('schema-venue-form-apps-are-required')),
    dateFrom: yup.date().required(t('schema-consumptionsReport-form-dateFrom-required')),
    dateTo: yup
      .date()
      .when(
        'fromDate',
        (fromDate, schema) =>
          fromDate && schema.min(moment(fromDate).add(1, 'minute'), t('schema-consumptionsReport-form-dateTo-when')),
      )
      .required(t('schema-consumptionsReport-form-dateTo-required')),
  });
